import i18n from '@/utils/i18n';

const sorting =
    [
        {
            name: "order",
            type: "select",
            placeholder: i18n.t('form.type_to_search'),
            main: true,
            options: [],
            orderFieldName: 'sort',
            defaultValue: { "label": "Total Views", "value": "total_views" },
            response_object: "order"
        }
    ];

export default sorting
